import React from 'react';

import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function DocumentAllowanceLimitReachedModal({ onClose }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'projectsDashboard.components.DocumentAllowanceLimitReachedModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('close')}
          </TextButton>
        </div>
      }
      isOpen={true}
      mode='letterbox'
      onClose={onClose}
    >
      <>
        <h2 className='modalbox-header__title truncated-text-container tw-border-0 tw-border-b-1 tw-border-solid tw-border-grey-100 tw-p-6 tw-text-xl tw-font-semibold tw-text-grey-900'>
          {i18nT('title')}
        </h2>
        <div className='modalbox-body'>
          <p className='tw-mb-0 tw-text-m tw-font-normal tw-text-grey-900'>
            <Trans
              components={{
                a: (
                  /* eslint-disable jsx-a11y/anchor-has-content */
                  <a
                    className='tw-text-m tw-font-medium tw-text-blue-500'
                    href='mailto:help@handshq.com?subject=Increase document allowance'
                  />
                  /* eslint-enable jsx-a11y/anchor-has-content */
                ),
              }}
              i18nKey='projectsDashboard.components.DocumentAllowanceLimitReachedModal.description'
              ns='components'
            />
          </p>
        </div>
      </>
    </ModalBox>
  );
}

DocumentAllowanceLimitReachedModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
